import Swiper, { Pagination, A11y } from 'swiper';

export default () => {
	// attorney slider

	const communitySlider = new Swiper('.cw-community__items .swiper', {
		modules: [Pagination, A11y],
		pagination: {
			el: '.cw-community__items .swiper-pagination',
			clickable: true,
		},
		loop: true,
		a11y: true,
		keyboardControl: true,
		grabCursor: true,
		slidesPerView: 1,
		sliderPerGroup: 1,
		spaceBetween: 80,
		centerInsufficientSlides: true,
		breakpoints: {
			320: {
				slidesPerView: 1,
				sliderPerGroup: 1,
				spaceBetween: 80,
			},
			768: {
				spaceBetween: 30,
				slidesPerView: 2,
				sliderPerGroup: 2,
			},
			992: {
				spaceBetween: 30,
				slidesPerView: 3,
				sliderPerGroup: 3,
			},
			1200: {
				enabled: false,
			},
		},
		on: {
			resize: function () {
				this.update();
				this.updateSlidesClasses();
				this.updateSlides();

				if (window.matchMedia('(min-width: 1200px)').matches) this.destroy();
			},
		},
	});

	if (window.matchMedia('(min-width: 1200px)').matches)
		communitySlider.destroy();
};
